import {BaseContainerModel} from '../base-container.model';
import {bl_pgw_label_list_hdr_RowClass} from '../../dbschema/bl_pgw_label_list_hdr.model';

export class PgwLabelListContainerModel extends BaseContainerModel {
  bl_pgw_label_list_hdr: bl_pgw_label_list_hdr_RowClass = new bl_pgw_label_list_hdr_RowClass();
}
